import { render, staticRenderFns } from "./PackagingDetail.vue?vue&type=template&id=4fc2740a&scoped=true"
import script from "./PackagingDetail.vue?vue&type=script&lang=js"
export * from "./PackagingDetail.vue?vue&type=script&lang=js"
import style0 from "./PackagingDetail.vue?vue&type=style&index=0&id=4fc2740a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc2740a",
  null
  
)

export default component.exports